import {FILE_DIFF_STATUS, type FileDiffStatus} from '../../types/file_tree.ts';

export function shouldShowLeaf(status: FileDiffStatus | null, nameHash: string, activeHash: string, showUnchangedSheets: boolean): boolean {
  const isActive = nameHash === activeHash;
  return (
    (status !== null && status !== FILE_DIFF_STATUS.UNCHANGED) ||
    isActive ||
    showUnchangedSheets
  );
}

export function statusIcon(status: FileDiffStatus): string {
  switch (status) {
    case FILE_DIFF_STATUS.ADDED:
      return 'octicon-diff-added';
    case FILE_DIFF_STATUS.DELETED:
      return 'octicon-diff-removed';
    case FILE_DIFF_STATUS.MODIFIED:
      return 'octicon-diff-modified';
    case FILE_DIFF_STATUS.RENAMED:
      return 'octicon-diff-renamed';
    case FILE_DIFF_STATUS.COPIED:
      return 'octicon-diff-renamed';
    case FILE_DIFF_STATUS.TYPECHANGED:
      return 'octicon-diff-modified';
    default:
      return '';
  }
}

export function statusClasses(status: FileDiffStatus): string[] | string {
  switch (status) {
    case FILE_DIFF_STATUS.ADDED:
      return ['text', 'green'];
    case FILE_DIFF_STATUS.DELETED:
      return ['text', 'red'];
    case FILE_DIFF_STATUS.MODIFIED:
      return ['text', 'yellow'];
    case FILE_DIFF_STATUS.RENAMED:
      return ['text', 'teal'];
    case FILE_DIFF_STATUS.COPIED:
      return ['text', 'green'];
    case FILE_DIFF_STATUS.TYPECHANGED:
      return ['text', 'yellow'];
    default:
      return '';
  }
}
